<template>
<div class="container">
    
    <h1>{{ title }}</h1>
    <div style="height:25px" aria-hidden="true"></div>
    <h2>箴言：君子慎独，修行，永远在路上。</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <p>freiwallet是一个记录个人，记录学习、记录分享的网站，主要记录和分享自己正在操作的项目，以及一些生活感悟，记录学习这世间的一些智慧。</p>
    <p>涉及的领域有比较遥远的宇宙，有比较现实的人性，有目前正在发展和参与的web3，还有未来趋势AI。</p>
    <p>人到了一定的年纪，结合自己的经历，能看清自己这辈子的追求，能知道自己这辈子需要争取的资源，内心实在是太想进步了。就是为了让自己有选择的自由，不要让很多面临选择的情况变成别无选择的结果。</p>
    <p>修身养性，提高自己的修养，磨练自己的心性。</p>
    <div style="height:25px" aria-hidden="true"></div>
    <div style="height:25px" aria-hidden="true"></div>
    <p>引用《西游记》的一首诗：</p>
    <div class="cont-center">
      <p>卖薪沽酒，狂笑自陶情</p>
      <p>苍径秋高，对月槐松根</p>
      <p>一觉天明</p>
    </div>
    <div style="height:25px" aria-hidden="true"></div>
    <div style="height:25px" aria-hidden="true"></div>
    <!--Start rollercoin.com code-->
    <a href="https://rollercoin.com/?r=lk0qxc8o">
      <img src="https://static.rollercoin.com/static/img/ref/gen2/w970h90.gif" alt="970h90"/>
    </a>
    <!--End rollercoin.com code-->
    
					
  </div>
</template>

<script>
export default{
    name: 'MyAbout',
    data(){
        // data 必须是一个函数，以避免多个实例间的数据共享
        return {
            title: '关于本站',
            
        }
    },
    methods: {
    // 定义事件处理函数
        updateTitle(newTitle) {
        this.title = newTitle;
        }
    },
    mounted() {
        // 组件挂载到 DOM 后执行
        console.log('组件已挂载');
    }
}
</script>

<style scoped>
.container {
  padding: 20px;
  background-color: #2f3045;
  color: #fff;
  max-width: 1200px;
  margin: 20px auto;
  width: 100%;
  box-sizing: border-box;
}

.cont-center{
  text-align: center;
  font-size: 2rem;
  font-family: cursive;
}

img{
  margin: auto;
}

</style>